<template>
  <section>
    <VerDetalle />
    <VerDetalleRegistro />

    <!-- Componentes externos -->
    <h3 class="primary--text">
      <v-icon color="primary">business</v-icon> Comisión Viajes
    </h3>
    <v-card
      color="rgba(69, 157, 147,0.10)"
      class="pt-2 pl-2 pb-2"
      elevation="4"
      v-if="this.datos_persona"
    >
      <v-layout row wrap>
        <v-flex xs12><b>NOMBRE: </b>{{ this.datos_persona.nombre }}</v-flex>
        <v-flex xs12><b>DEPENDENCIA: </b></v-flex>
        <v-flex
          xs12
          v-for="unidad in this.datos_persona.unidades"
          :key="unidad.id"
          ><v-icon>domain</v-icon> {{ unidad.nombre_unidad }}</v-flex
        >
        <v-flex xs12><b>CARGO: </b>{{ this.datos_persona.cargo }}</v-flex>
      </v-layout>
    </v-card>
    <br />
    <v-card>
      <v-card-text>
        <crud-table
          :headers="headers"
          :url="url"
          :filters="filters"
          :data-graphql="dataGraphql"
          :graphql="graphql"
          :initData="initData"
        >
          <!-- Template injectable de la cabecera de la tabla -->
          <template slot="buttons">
            <!-- <v-tooltip bottom>
             <v-btn color="primary" dark
               @click.native.stop="crearActualizarComisionViaje({})"
               slot="activator"
             ><v-icon dark>add</v-icon> {{$t('common.add') }}</v-btn>
             <span>Agregar Comision viaje</span>
           </v-tooltip> -->
          </template>

          <!-- Template de filas y columnas -->
          <template slot="items" slot-scope="items">
            <!-- Agregar las columnas que consideré necesarias -->
            <td class="text-xs-center">{{ items.item.cite }}</td>
            <td class="text-xs-center">
              {{ items.item.fecha_registro }}
            </td>
            <td class="text-xs-center">
              {{ items.item.fecha_salida }}
            </td>
            <td class="text-xs-center">
              {{ items.item.fecha_retorno }}
            </td>
            <td class="text-xs-center">{{ items.item.estado }}</td>

            <td class="nowrap text-xs-center">
              <v-tooltip bottom>
                <v-btn
                  color="green"
                  icon
                  slot="activator"
                  @click.prevent="verDetalleViajeRegistro(items.item.id)"
                >
                  <v-icon>visibility</v-icon>
                </v-btn>
                <span>Ver registro</span>
              </v-tooltip>
                          <v-tooltip bottom>
                <v-btn
                  color="purple"
                  icon
                  dark
                  slot="activator"
                  @click.prevent="eliminaRegistro(items.item.id)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
                <span>Eliminar</span>
              </v-tooltip>
            </td>
          </template>
        </crud-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table/CrudTable.vue"; // Componente Tabla Dinámica
import crud from "@/common/util/crud-table/mixins/crud-table"; // Funciones y Metodos
import VerDetalle from "./dialogs/VerDetalle"; // Componente de creación y actualización
import VerDetalleRegistro from "./dialogs/VerDetalleRegistro"; // Componente de creación y actualización

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [crud],
  // Variables iniciales del componente
  data() {
    return {
      url: "vViajePorPersonas",
      graphql: true,
      datos_persona: {},
      // Cabecera de la tabla
      headers: [
        { text: "Cite", value: "cite", align: "center", sortable: false },
        {
          text: "Fecha registro",
          value: "fecha_registro",
          align: "center",
          sortable: false
        },
        {
          text: "Fecha salida",
          value: "fecha_salida",
          align: "center",
          sortable: false
        },
        {
          text: "Fecha retorno",
          value: "fecha_retorno",
          align: "center",
          sortable: false
        },
        { text: "Estado", value: "estado", align: "center", sortable: false },
        { text: this.$t("common.actions"), sortable: false, align: "center" }
      ],
      // Campos solicitados de Graphql(Agregar los que necesite)
      dataGraphql: `
        id
        fecha_registro
        fecha_salida
        fecha_retorno
        estado
        cite
        id_estado
      `,
      // Filtros del componente CrudTable ejemplo:
      // {
      // 	field: 'Campo definido en Graphql',
      // 	label: 'Etiqueta del input generado',
      // 	type: 'text', // Tipo de input en el filtro
      // 	typeG: 'String' // Tipo definido en Graphql
      // }
      initData: [
        {
          state: true,
          param: "id_persona",
          value: this.getPersonaId()
        }
      ],
      filters: [
        {
          field: "cite",
          label: "Cite",
          type: "text", // Tipo de input en el filtro
          typeG: "String" // Tipo definido en Graphql
        },
        {
          field: "fecha_registro",
          label: "Fecha registro",
          type: "text", // Tipo de input en el filtro
          typeG: "String" // Tipo definido en Graphql
        },
        {
          field: "fecha_salida",
          label: "Fecha salida",
          type: "text", // Tipo de input en el filtro
          typeG: "String" // Tipo definido en Graphql
        },
        {
          field: "fecha_retorno",
          label: "Fecha retorno",
          type: "text", // Tipo de input en el filtro
          typeG: "String" // Tipo definido en Graphql
        },
        {
          field: "estado",
          label: "Estado",
          type: "text", // Tipo de input en el filtro
          typeG: "String" // Tipo definido en Graphql
        }
      ]
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
    this.onFilter();
    // Cargamnos datos de la persona
    await this.cargarDatosPersona();
    this.$bus.$on("closeDialog", () => {
      this.updateList();
    });
  },
  // Métodos y funciones del componente
  methods: {
    // Metodo para cargar los datos de la persona
    async cargarDatosPersona() {
      try {
        const id_persona = this.getPersonaId();
        let rpta = await this.$service.graphql({
          query: `query{
            vListaPersonals(id_persona: ${id_persona}){
              rows{
                id_persona
                nombre
                cargo
                puesto
                id_unidad
                padres_unidad
                activo_pasivo
              }
            }
          }`
        });
        var datos_tmp = rpta.vListaPersonals.rows[0];
        var id_unidad = datos_tmp.id_unidad;
        var lista_unidades = [];
        while (id_unidad) {
          let unidad = await this.obtenerUnidad(id_unidad);
          lista_unidades.push(unidad);
          id_unidad = unidad.parent_id;
        }
        datos_tmp.unidades = lista_unidades.reverse();
        this.datos_persona = datos_tmp;
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerUnidad(id_unidad) {
      try {
        let res = await this.$service.graphql({
          query: `
						query{
							unidad(id: ${id_unidad}){
								id
								nombre_unidad
								nivel
                parent_id
							}
						}
					`
        });
        return res.unidad;
      } catch (error) {
        console.log(error);
      }
    },
    verDetalleViaje() {
      this.$bus.$emit("openDialogVerDetalle");
    },
    verDetalleViajeRegistro(id) {
      this.$bus.$emit("openDialogVerDetalleRegistro", id);
    },

    getPersonaId() {
      return parseInt(this.$route.params.id_persona);
    },
    async eliminaRegistro(id) {
      this.$confirm("Desea eliminar el registro?. Esta acción es irreversible", async () => {
        let respuesta;
        let resps;
        let user = this.$storage.get("user");
        let consulta = `SELECT CONTROL.fn_elimina_comision(${parseInt(
          id
        )},${parseInt(user.id)})`;
        try {
          respuesta = await this.$service.graphql({
            query: `
              query{
              runQuery(consulta:"${consulta}"){
                respuesta
              }
              }
            `
          });
          respuesta = respuesta.runQuery.respuesta[0].fn_elimina_comision;
          resps = respuesta.split("|");
          let correcto = resps[0];
          if (correcto === "1") {
            this.$message.success("El registro fué eliminado exitosamente");
          } else {
            this.$message.error(resps[1]);
          }
        } catch (error) {
          console.log(error);
        }
        this.updateList();
      });
    }
  },
  // Definición de componentes importados
  components: {
    CrudTable,
    VerDetalle,
    VerDetalleRegistro
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/comision_viaje/ListadoViajeDetalle.vue